import React from 'react';

interface TagProps {
  text: string;
  icon?: string;
  url?: string;
  hasBackground?: boolean;
}

const Tag: React.FC<TagProps> = ({ text, icon, url, hasBackground = false }) => {
  const iconClass = icon ? 'tag--icon' : '';
  const linkClass = url ? 'tag--link' : '';
  const backgroundClass = hasBackground ? 'tag--background' : '';
  const combinedClass = `tag ${iconClass} ${linkClass} ${backgroundClass}`;

  const iconMarkup = icon ? <div className="tag__icon" style={{ maskImage: `url(${icon})` }}></div> : null;

  return (
    <>
      {url ? (
        <a href={url} className={`tag-link ${combinedClass}`}>
          {iconMarkup}
          <div className="tag__text">{text}</div>
        </a>
      ) : (
        <div className={combinedClass}>
          {iconMarkup}
          <div className="tag__text">{text}</div>
        </div>
      )}
    </>
  );
};

export default Tag;
